import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SettingsService, SETTINGS_KEYS } from '../services/settings.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiOrigin)) {
    return next(req);
  }

  const router = inject(Router);
  const settings = inject(SettingsService);

  return next(req.clone({
    withCredentials: true,
    setHeaders: { 'x-requested-by': environment.requestedBy },
  })).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        settings.remove(SETTINGS_KEYS.AUTH_USER);
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
